"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFontSize = void 0;
function calculateFontSize(size, titleText, titleContainer) {
    const step = 2;
    const widthEpsilon = 24;
    const heightEpsilon = 10;
    let fontSize = size;
    if (titleText && titleContainer) {
        const titleRect = titleText.getBoundingClientRect();
        const containerRect = titleContainer.getBoundingClientRect();
        const titleWidth = titleRect.width;
        const titleHeight = titleRect.height;
        const containerWidth = containerRect.width;
        const containerHeight = containerRect.height;
        /**
         * To prevent endless fontsize update check if text width smaller than container width for more than epsilon
         */
        if (titleWidth < containerWidth &&
            titleHeight < containerHeight &&
            containerWidth - titleWidth > widthEpsilon &&
            containerHeight - titleHeight > heightEpsilon) {
            fontSize += step;
        }
        else if (titleWidth > containerWidth || titleHeight > containerHeight) {
            fontSize -= step;
        }
        return fontSize;
    }
}
exports.calculateFontSize = calculateFontSize;
